import { Button, Text } from '@mantine/core'

import { Toast } from '#components/Toast'

import { isAtPlanSeatMax } from './seatMath'
import { WorkspaceSeatData } from './types'

const WARNING_DARK = '#876a03'

export type SeatWarningBannerProps = {
  workspace: WorkspaceSeatData
  onManagePlan: () => void
}

export const SeatWarningBanner = ({
  workspace,
  onManagePlan,
}: SeatWarningBannerProps) => {
  const { seats, seatMode, canManagePlan } = workspace
  const full =
    isAtPlanSeatMax(seats, seatMode) &&
    (seatMode === 'dynamic' || seats.available <= 0)
  if (!full) return null

  const remedy = canManagePlan
    ? 'Change your plan to invite new members.'
    : 'Contact your workspace owner to change the plan.'

  return (
    <Toast
      type="warning"
      dismissable={false}
      message={
        <div>
          <Text fw="bold" fz={14}>
            No seats available.
          </Text>
          <Text fz={14}>
            This plan has a maximum of {seats.planMax} seats. {remedy}
          </Text>
        </div>
      }
    >
      {canManagePlan ? (
        <Button variant="outline" color={WARNING_DARK} onClick={onManagePlan}>
          Manage Plan
        </Button>
      ) : null}
    </Toast>
  )
}
